// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAachVV7YVfmxG4YRuhel46ZBbmCxcvcCk",
    authDomain: "vaxtrax-527ac.firebaseapp.com",
    projectId: "vaxtrax-527ac",
    storageBucket: "vaxtrax-527ac.appspot.com",
    messagingSenderId: "662518844664",
    appId: "1:662518844664:web:6e534c17177d3ca1623f0d",
    measurementId: "G-0YM855NCXV"
};

// Initialize Firebase
console.log('Initializing firebase');
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);